"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Components = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledSystem = require("styled-system");
var _constant = require("../../styles/constant");
var _Button = _interopRequireDefault(require("../Button"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
const fit = (0, _styledSystem.variant)({
  prop: 'fit',
  variants: {
    small: {
      fontSize: (0, _constant.get)('fontSizes.14'),
      height: (0, _constant.get)('space.20'),
      lineHeight: (0, _constant.get)('lineHeights.20'),
      padding: props => "".concat((0, _constant.get)('space.5')(props), " ").concat((0, _constant.get)('space.11')(props))
    },
    medium: {
      fontSize: (0, _constant.get)('fontSizes.16'),
      height: (0, _constant.get)('space.24'),
      lineHeight: (0, _constant.get)('lineHeights.24'),
      padding: props => "".concat((0, _constant.get)('space.7')(props), " ").concat((0, _constant.get)('space.15')(props))
    },
    large: {
      fontSize: (0, _constant.get)('fontSizes.16'),
      height: (0, _constant.get)('space.24'),
      lineHeight: (0, _constant.get)('lineHeights.24'),
      padding: props => "".concat((0, _constant.get)('space.11')(props), " ").concat((0, _constant.get)('space.16')(props))
    }
  }
});
const buttonVariant = (0, _styledSystem.variant)({
  prop: 'variant',
  variants: {
    plain: {
      '&:focus-visible': {
        outline: 'none',
        borderColor: (0, _constant.get)('colors.primary.blue.400'),
        boxShadow: (0, _constant.get)('boxShadows.type.basic.default')
      }
    }
  }
});
const variants = {
  buttonVariant,
  fit
};
const ParentWrapper = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: start;\n  justify-content: start;\n  flex-direction: row;\n"])));
const Wrapper = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  max-width: 100%;\n  overflow: auto;\n"])));
const List = _styledComponents["default"].ul(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  padding: 0;\n  margin: 0;\n"])));
const Item = _styledComponents["default"].li(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  list-style: none;\n"])));
const paginationDefault = (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n"])), (0, _constant.get)('colors.functional.grey.900'), (0, _constant.get)('colors.functional.grey.200'), (0, _constant.get)('colors.functional.grey.700'));
const paginationActive = (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  position: relative;\n  color: ", ";\n  background-color: ", ";\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n"])), (0, _constant.get)('colors.functional.grey.50'), (0, _constant.get)('colors.primary.blue.900'), (0, _constant.get)('colors.primary.blue.800'), (0, _constant.get)('colors.functional.grey.50'));
const paginationDisabled = props => {
  const color = "".concat((0, _constant.get)('colors.functional.grey.800')(props), "80");
  return (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n    cursor: not-allowed;\n    color: ", ";\n  "])), color);
};
const Link = _styledComponents["default"].a.attrs(_ref => {
  let {
    disabled,
    children,
    variant = 'default',
    onClick
  } = _ref;
  return {
    disabled,
    variant,
    children,
    onClick
  };
})(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n\n  ", "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  border-radius: ", ";\n  &:last {\n    margin-right: 0;\n  }\n  ", "\n"])), props => props.disabled && {
  cursor: 'not-allowed'
}, variants.fit, (0, _constant.get)('borderRadius.m'), props => props.variant === 'active' ? paginationActive : props.variant === 'disabled' ? paginationDisabled(props) : paginationDefault);
const Select = _styledComponents["default"].div(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n  display: inline-flex;\n  align-items: center;\n  > div {\n    flex-direction: row;\n    align-items: center;\n    > div {\n      margin-right: ", ";\n    }\n  }\n  div:nth-child(2) {\n    div[class*='container'] {\n      width: ", ";\n    }\n  }\n"])), (0, _constant.get)('space.8'), (0, _constant.get)('space.78'));
const Nav = _styledComponents["default"].nav(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  justify-content: space-between;\n  max-height: ", ";\n"])), (0, _constant.get)('space.40'));
const SelectLabel = _styledComponents["default"].label(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  margin-right: ", ";\n"])), (0, _constant.get)('colors.functional.grey.900'), (0, _constant.get)('fontWeights.regular'), (0, _constant.get)('fontSizes.16'), (0, _constant.get)('space.8'));
const PaginationButton = (0, _styledComponents["default"])(_Button["default"])(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n"])), variants.buttonVariant);
const Components = exports.Components = {
  Item,
  Link,
  List,
  Nav,
  PaginationButton,
  ParentWrapper,
  Select,
  SelectLabel,
  Wrapper
};